window.addEventListener('cart-show', async () => {
 console.log('cart-show');
  const cart = await fetch('/cart?view=ajax')
    .then(res => res.text())

  const html= new DOMParser().parseFromString(cart, 'text/html');

  document.querySelectorAll('.rebuy-cart__flyout-item').forEach(rebuyLine => {
    const key = rebuyLine.dataset.key

    if (rebuyLine.querySelector('.rebuy-cart__flyout-item-bundle')) {
      rebuyLine.querySelector('.rebuy-cart__flyout-item-bundle').innerHTML = html.querySelector(`.cart-item[data-key="${key}"] .rebuy-cart__flyout-item-bundle-children`).innerHTML
      rebuyLine.querySelector('.rebuy-cart__flyout-item-bundle').classList.remove('hidden')
    }
  })
})
